<template>
  <el-col class="flex-box al-c" :span="sift.col * 2 || col * 2" :style="fold && !sift.fixed ? 'display:none' : ''">
    <span class="mr10 tx-r" :style="{ width: labelWidth + 'em' }">{{ sift.label }}</span>
    <el-date-picker
            :clearable="!sift.indelible"
            class="flex-1"
            v-model="beginDate"
            :type="sift.pickerType || 'date'"
            placeholder="开始时间"
            :format="sift.sysDatasourceQuery ? sift.optionalType : 'yyyy-MM-dd'"
            value-format="yyyy-MM-dd hh:mm:ss"
            :picker-options="beginOption"
            @change="changeValue"
    ></el-date-picker>
    <span class="ml10 mr10">至</span>
    <el-date-picker
            :clearable="!sift.indelible"
            class="flex-1"
            v-model="endDate"
            :type="sift.pickerType || 'date'"
            placeholder="结束时间"
            :format="sift.sysDatasourceQuery ? sift.optionalType : 'yyyy-MM-dd'"
            value-format="yyyy-MM-dd hh:mm:ss"
            :picker-options="endOption"
            @change="changeValue"
    ></el-date-picker>
  </el-col>
</template>

<script>
    import moment from "moment";

    export default {
        name: "SiftBEDate",
        props: ["sift", "col", "label-width", "fold"],
        components: {},
        data() {
            return {
                beginDate: null,
                endDate: null,

                beginOption: {
                    disabledDate: time => {
                        if (
                            (this.sift.min && time < this.sift.min) ||
                            (this.sift.max && time > this.sift.max) ||
                            (this.endDate && time > this.endDate)
                        ) {
                            return true;
                        }
                        return false;
                    }
                },
                endOption: {
                    disabledDate: time => {
                        if (
                            (this.sift.min && time < this.sift.min) ||
                            (this.sift.max && time > this.sift.max) ||
                            (this.beginDate && time < this.beginDate)
                        ) {
                            return true;
                        }
                        return false;
                    }
                }
            };
        },
        created() {
            // if (this.sift.defaultValue) {
            //   const date = this.sift.defaultValue.split(",");
            //   this.beginDate = date[0];
            //   this.endDate = date[1];
            // }
        },
        mounted() {},
        destroyed() {},
        methods: {
            setValue(value) {
                var obj ={}
                if (typeof(value) == "string") {
                    const date = value.split(",");
                    this.beginDate = date[0];
                    this.endDate = date[1];
                } else if (typeof obj == "object" && obj.constructor == Array) {
                    this.beginDate = value[0];
                    this.endDate = value[1];
                }
                obj.beginDate = this.beginDate;
                obj.endDate = this.endDate;
                return obj
            },
            getValue() {
                if (this.sift.sysDatasourceQuery) {
                    const keyName = this.sift.key.split(",");
                    const obj = {};
                    const start = this.beginDate ? this.beginDate : null;
                    // const end = this.endDate ? this.endDate + 86399000 : null;
                    let end;
                    if (this.endDate) {
                        if (this.sift.pickerType === "datetime") {
                            end = this.endDate;
                        } else {
                            end = this.endDate + 86399000;
                        }
                    }
                    let sValue = null;
                    let eValue = null;
                    if (start) {
                        let sYear = new Date(start).getFullYear();
                        let sMonth = new Date(start).getMonth() + 1;
                        sMonth = sMonth < 10 ? "0" + sMonth : sMonth;
                        let sDate = new Date(start).getDate();
                        sDate = sDate < 10 ? "0" + sDate : sDate;
                        let sHour = new Date(start).getHours();
                        sHour = sHour < 10 ? "0" + sHour : sHour;
                        let sMinute = new Date(start).getMinutes();
                        sMinute = sMinute < 10 ? "0" + sMinute : sMinute;
                        let sSecond = new Date(start).getSeconds();
                        sSecond = sSecond < 10 ? "0" + sSecond : sSecond;
                        // sValue = `${sYear}-${sMonth}-${sDate}`;
                        if (this.sift.pickerType === "datetime") {
                            sValue = `${sYear}-${sMonth}-${sDate} ${sHour}:${sMinute}:${sSecond}`;
                        } else {
                            sValue = `${sYear}-${sMonth}-${sDate}`;
                        }
                    }
                    if (end) {
                        let eYear = new Date(end).getFullYear();
                        let eMonth = new Date(end).getMonth() + 1;
                        eMonth = eMonth < 10 ? "0" + eMonth : eMonth;
                        let eDate = new Date(end).getDate();
                        eDate = eDate < 10 ? "0" + eDate : eDate;
                        let eHour = new Date(start).getHours();
                        eHour = eHour < 10 ? "0" + eHour : eHour;
                        let eMinute = new Date(start).getMinutes();
                        eMinute = eMinute < 10 ? "0" + eMinute : eMinute;
                        let eSecond = new Date(start).getSeconds();
                        eSecond = eSecond < 10 ? "0" + eSecond : eSecond;
                        // eValue = `${eYear}-${eMonth}-${eDate}`;
                        if (this.sift.pickerType === "datetime") {
                            eValue = `${eYear}-${eMonth}-${eDate} ${eHour}:${eMinute}:${eSecond}`;
                        } else {
                            eValue = `${eYear}-${eMonth}-${eDate}`;
                        }
                    }
                    // obj[keyName] = [sValue, eValue];
                    obj[keyName[0]] = sValue;
                    obj[keyName[1]] = eValue;
                    return obj;
                } else {
                    const keyName = this.sift.key.split(",");
                    const obj = {};
                    obj[keyName[0]] = this.beginDate ? this.beginDate : null;
                    obj[keyName[1]] = this.endDate ? this.endDate + 86399000 : null;
                    return obj;
                }
            },
            resetValue() {
                if (this.sift.indelible) {
                    return;
                }
                this.beginDate = null;
                this.endDate = null;
            },
            changeValue() {
                if ((this.beginDate && this.endDate) || (!this.beginDate && !this.endDate)) {
                    this.$emit("change");
                }
            }
        },
        watch: {
            "sift.defaultValue": {
                handler(val, oldVal) {
                    const date = val.split(",");
                    this.beginDate = date[0];
                    this.endDate = date[1];
                },
                immediate: true
            },
            beginDate(val) {
                console.log(val);
            },
            endDate(val) {
                console.log(val);
            }
        },
        filters: {}
    };
</script>

<style scoped></style>
